import { render, staticRenderFns } from "./multiindex.vue?vue&type=template&id=b245bd9e&scoped=true&"
import script from "./multiindex.vue?vue&type=script&lang=js&"
export * from "./multiindex.vue?vue&type=script&lang=js&"
import style0 from "./multiindex.vue?vue&type=style&index=0&id=b245bd9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b245bd9e",
  null
  
)

export default component.exports